// Support ticket priorities. The backend sends and filters by the priority
// name ("Urgent", "High", "Medium", "Low"). Each priority carries the
// support SLA shown in the ticket drawer.
export const TICKET_PRIORITIES = [
  { label: "Urgent", sla: "12 hours" },
  { label: "High", sla: "24 hours" },
  { label: "Medium", sla: "36 hours" },
  { label: "Low", sla: "48 hours" },
];

const findPriority = (priority) =>
  TICKET_PRIORITIES.find(
    (item) => item.label.toLowerCase() === priority?.toLowerCase()
  );

export const getPrioritySla = (priority) => findPriority(priority)?.sla ?? null;

// Soft tinted pills, same palette as the priority pills in the design reference
// (red for Critical/Urgent, neutral gray for Medium).
const PRIORITY_STYLES = {
  Urgent: { background: "#FDECEC", color: "#D93636" },
  High: { background: "#FFF1E6", color: "#C2570C" },
  Medium: { background: "#F1F2F7", color: "#4B5266" },
  Low: { background: "#E7F7EE", color: "#12945A" },
};

const GRAY_STYLE = { background: "#F1F2F7", color: "#4B5266" };

// Colored pill for a support ticket's priority; a plain "-" for tickets
// without one. Matching is case-insensitive, unknown values show as-is
// in gray.
const TicketPriorityPill = ({ priority }) => {
  if (!priority) return <span className="text-gray-400">-</span>;

  const label = findPriority(priority)?.label ?? priority;

  return (
    <span
      style={{
        ...(PRIORITY_STYLES[label] ?? GRAY_STYLE),
        borderRadius: "999px",
        padding: "0.25rem 0.75rem",
        fontSize: "0.75rem",
        fontWeight: 600,
        lineHeight: 1.4,
        whiteSpace: "nowrap",
        display: "inline-block",
      }}
    >
      {label}
    </span>
  );
};

export default TicketPriorityPill;
